<script setup lang="ts">
import {storeToRefs} from "pinia";

const props = defineProps<{
  title?: string;
}>();

const settingsStore = useSettingsStore();
const { _settings:settings } = storeToRefs(settingsStore);

const socials = computed(() => settings.value?.socials);
const haveSocials = computed(() => Object.keys(socials.value).length > 0);


</script>

<template>
  <div class="mb-2 mt-3" v-if="haveSocials && title">{{ title }}</div>

  <div class="socials">
    <a
        v-if="socials?.viber"
        :href="'viber://chat?number='+socials.viber"
        rel="noopener noreferrer nofollow"
        aria-label="Viber"
        title="Viber"
    >
      <Icon name="fa6-brands:viber" />
      <span class="visually-hidden">Viber</span>
    </a>

    <a
        v-if="socials?.facebook"
        :href="socials.facebook"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="Facebook"
        title="Facebook"
    >
      <Icon name="fa6-brands:facebook" />
      <span class="visually-hidden">Facebook</span>
    </a>

    <a
        v-if="socials?.instagram"
        :href="socials.instagram"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="Instagram"
        title="Instagram"
    >
      <Icon name="fa6-brands:instagram" />
      <span class="visually-hidden">Instagram</span>
    </a>

    <a
        v-if="socials?.google"
        :href="socials.google"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="Google"
        title="Google"
    >
      <Icon name="fa6-brands:google" />
      <span class="visually-hidden">Google</span>
    </a>

    <a
        v-if="socials?.youtube"
        :href="socials.youtube"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="YouTube"
        title="YouTube"
    >
      <Icon name="fa6-brands:youtube" />
      <span class="visually-hidden">YouTube</span>
    </a>

    <a
        v-if="socials?.tiktok"
        :href="socials.tiktok"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="TikTok"
        title="TikTok"
    >
      <Icon name="fa6-brands:tiktok" />
      <span class="visually-hidden">TikTok</span>
    </a>

    <a
        v-if="socials?.x"
        :href="socials.x"
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label="X (Twitter)"
        title="X (Twitter)"
    >
      <Icon name="fa6-brands:x-twitter" />
      <span class="visually-hidden">X (Twitter)</span>
    </a>
  </div>
</template>

<style scoped>
.socials {
  display: flex;
  align-items: center;
  gap: 20px;
  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
  a {
  }
}
</style>